import { makeStyles } from "@material-ui/core";

const styles = makeStyles(() => ({
  add: {
    marginLeft: "auto",
  },
}));

export default styles;
